<template>
  <AppLayout>
    <div class="inventory">
      <section id="suppliers-add" class="filter-search">
        <div class="container">
          <h6 class="mb-3 fw-bold">Generate Purchase Order</h6>
          <p class="fw-bold">1. Add Details</p>
          <div>
            <div class="form">
              <div class="row">
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="product-name">Department</label>
                    <select  v-model="department" class="full"  v-if="departments.length > 0">
                      <option :value="null">-- Select department --</option>
                      <option v-for="dept in departments" v-bind:key="dept.id" :value="dept.id">
                          {{ dept.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="item-code">Project</label>
                    <!--<input type="text" class="form-control" id="item-code" v-model="project">-->
                    <select v-model="project" class="full" id="projects"  v-if="projects?.length > 0">
                      <option v-for="proj in projects" v-bind:Key="proj.id" :value="proj.name">
                          {{ proj.name }}
                      </option>
                    </select>
                  </div>
                </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="tender">Tender (optional)</label>
                      <select v-model="tenderId" @change="onTenderChange" class="full" id="tender" v-if="tenders.length > 0">
                        <option value="">-- None --</option>
                        <option v-for="t in tenders" :key="t.id" :value="t.id">{{ t.title }} {{ t.referenceNumber ? '(' + t.referenceNumber + ')' : '' }}</option>
                      </select>
                    </div>
                  </div>
                              <div class="col-md-3" v-if="tenderSubmissions && tenderSubmissions.length > 0">
                                <div class="form-group">
                                  <label for="award">Awarded Submission (optional)</label>
                                  <select v-model="tenderSubmissionId" class="full" id="award" v-if="tenderSubmissions && tenderSubmissions.length > 0" :disabled="tenderSubmissionDisabled">
                                    <option :value="null">-- None --</option>
                                    <option v-for="s in tenderSubmissions" :key="s.id" :value="s.id">{{ s.companyName }} {{ s.proposedValue ? '(' + s.proposedValue + ')' : '' }}</option>
                                  </select>
                                </div>
                              </div>
                              <div class="col-md-3">
                                <div class="form-group">
                                  <label for="suppliers">Supplier</label>
                                  <select v-model="supplierId" class="full" id="suppliers"  v-if="suppliers.length > 0">
                                      <option v-for="supplier in suppliers" v-bind:Key="supplier.id" :value="supplier.id">
                                          {{ supplier.name }}
                                      </option>
                                  </select>
                                </div>
                              </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="supplierContact">Contacts</label>
                    <input type="text" class="form-control" id="supplierContact" readonly v-model="supplierContact">
                  </div>
                </div>
                <!--<div class="col-md-2">
                  <div class="form-group">
                    <label for="payments">Terms of Payment</label>
                    <select v-model="paymentId" class="full" id="payments"  v-if="payments.length > 0">
                        <option v-for="payment in payments" v-bind:Key="payment.id" :value="payment.id">
                            {{ payment.payment }}
                        </option>
                    </select>
                  </div>
                </div>-->

                <div class="col-md-2">
                  <div class="form-group">
                    <label for="item-code">Requisition Number</label>
                    <input type="text" class="form-control" id="item-code" v-model="requisitionNumber" readonly />
                  </div>
                </div>

                <div class="col-md-1">
                  <div class="form-group">
                    <label for="item-code">VAT {{vat}}</label>
                    <div class="components-button">
                      <span class="switcher switcher-1">
                        <input type="checkbox" id="switcher-1" v-model="vat">
                        <label for="switcher-1"></label>
                      </span>
                    </div>
                  </div>
                </div>
              
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="discount">Discount</label>
                    <input type="number" step="0.01" min="0" class="form-control" v-model.number="discount" />
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="form-group">
                    <label for="deliveryDate">Delivery Date</label>
                    <input type="date" class="form-control" id="deliveryDate" v-model="deliveryDate" />
                  </div>
                </div>

              
                <div class="col-md-1" v-if="!tenderId" :style="{ 'display': displayButton }">
                    <button class="btn btn-style-2" style="margin-top: 31px;" @click="postPurchase" :disabled="creatingPurchase">
                      <span v-if="creatingPurchase">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        &nbsp;Creating...
                      </span>
                      <span v-else>Add</span>
                    </button>
                </div>

                
              </div>
  
            </div>
          </div> <!-- v-if="tenderId || purchaseId"  -->
          <div  style="margin-top:30px"  v-if="tenderId || purchaseId">
            <p class="fw-bold">2. Add Products</p>
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label for="supplierContact">Product Name</label>
                  <div style="display:flex; gap:8px; align-items:center">
                    <select v-model="productId" class="full form-control" id="products"  v-if="products.length > 0">
                      <option v-for="product in products" v-bind:Key="product.id" :value="product.id">
                          {{ product.name }}
                      </option>
                    </select>
                    <button class="btn btn-sm btn-outline-primary" type="button" @click="openNewProductModal">New</button>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label for="supplierContact">Product Code</label>
                  <input type="text" readonly v-model="productCode" class="form-control">
                </div>
              </div>
              <div class="col-md-1">
                <div class="form-group">
                  <label for="supplierContact">Unit</label>
                  <input type="text" readonly v-model="productUnit" class="form-control">
                </div>
              </div>
              <!--<div class="col-md-2">
                <div class="form-group">
                  <label for="supplierContact">Product Description</label>
                  <input type="text" v-model="productDescription" class="form-control">
                </div>
              </div>-->
              <div class="col-md-2">
                <div class="form-group">
                  <label for="supplierContact">Qty Requested</label>
                  <input type="number" min="0" v-model.number="productRequest" class="form-control">
                </div>
              </div>
              <div class="col-md-1">
                <div class="form-group">
                  <label for="supplierContact">Price per item</label>
                  <input type="number" step="0.01" min="0" v-model.number="productPrice" class="form-control">
                </div>
              </div>
              <div class="col-md-1">
                <div class="form-group">
                  <label for="supplierContact">Amount</label>
                  <input type="number" step="0.01" min="0" class="form-control" :value="productAmount" disabled>
                </div>
              </div>
              <div class="col-md-1">
                <div class="form-group">
                  <label for="supplierContact">Action</label><br>
                  <button class="btn btn-default pull-right" style="border:1px solid black;" @click="postProduct">Add</button>
                </div>
              </div>
            </div>

            <p></p>
            <p></p>

            <!--<strong class="mt-5" style="margin-top:30px !important">3. Product List</p>-->
            <table class="table table-hover">
                <thead>
                    <th style="background-color: #f8f9fa; font-size: 12px; font-weight: 600; padding: 15px 8px; text-align: left;">No.</th>
                    <th style="background-color: #f8f9fa; font-size: 12px; font-weight: 600; padding: 15px 8px; text-align: left;">Product</th>
                    <th style="background-color: #f8f9fa; font-size: 12px; font-weight: 600; padding: 15px 8px; text-align: left;">Product Code</th>
                    <th style="background-color: #f8f9fa; font-size: 12px; font-weight: 600; padding: 15px 8px; text-align: left;">Product Description</th>
                    <th style="background-color: #f8f9fa; font-size: 12px; font-weight: 600; padding: 15px 8px; text-align: left;">Unit</th>
                    <th style="background-color: #f8f9fa; font-size: 12px; font-weight: 600; padding: 15px 8px; text-align: left;">Qty In Tender</th>
                    <th style="background-color: #f8f9fa; font-size: 12px; font-weight: 600; padding: 15px 8px; text-align: left;">Qty Available</th>
                    <th style="background-color: #f8f9fa; font-size: 12px; font-weight: 600; padding: 15px 8px; text-align: left;">Qty Requesting</th>
                    <th style="background-color: #f8f9fa; font-size: 12px; font-weight: 600; padding: 15px 8px; text-align: left;">Price</th>
                    <th style="background-color: #f8f9fa; font-size: 12px; font-weight: 600; padding: 15px 8px; text-align: left;">Action</th>
                </thead>
                <tbody v-if="items.length > 0">
                    <tr v-for="(item, index) in items" v-bind:key="item.id">

                        <td>{{ (index+1) }}</td>
                        <td>{{ item.Product.name }}</td>
                        <td>{{ item.Product.code }}</td>
                        <td>{{ item.description }}</td>
                            <td>{{ item.Product.unit.unit }}</td>
                            <td>{{ item.tenderedQuantity ?? '-' }}</td>
                            <td>{{ item.availableQuantity !== null && item.availableQuantity !== undefined ? item.availableQuantity : '-' }}</td>
                            <td>
                              <input
                                type="number"
                                min="0"
                                step="1"
                                class="form-control"
                                v-model.number="item.quantity"
                                :max="(item.availableQuantity !== null && item.availableQuantity !== undefined) ? item.availableQuantity : undefined"
                              />
                            </td>
                        <td>
                          <input type="number" step="0.01" min="0" class="form-control" v-model.number="item.price" />
                        </td>
                        <td>
                            <button class="btn btn-default btn-sm" style="border:1px solid black;" @click="deleteProduct(item.id)">Remove</button>
                        </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>Total</td>
                      <td>{{ formatMoney(total) }}</td>
                      <td></td>
                    </tr>
                </tbody>
                <div v-else>
                  <label for="" class="text-danger" style="margin: 0px;  display: block;">No product found</label>
                </div>
            </table>
  
            <div class="mb-5">
              <button class="btn-style small" style="border: 1px solid black; float: right;" @click="generatePurchase" :disabled="generatingPurchase">
                <span v-if="generatingPurchase">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  &nbsp;Generating...
                </span>
                <span v-else>Generate</span>
              </button>
              <!--<button class="btn btn-default" style="border: 1px solid black; float: right; margin-right: 10px;" @click="$router.push('/purchases')">Close</button>-->
            </div>
          </div>
        
        <!-- New Product Modal -->
        <Modal v-if="showNewProductModal" @close="closeNewProductModal">
          <template #header>
            Create Product
          </template>
          <template #body>
            <div class="form-group">
              <label>Name</label>
              <input class="form-control" v-model="newProduct.name" />
            </div>
            <div class="form-group">
              <label>Code</label>
              <input class="form-control" v-model="newProduct.code" />
            </div>
            <div class="form-group">
              <label>Unit</label>
              <select class="form-control" v-model.number="newProduct.unitId">
                <option :value="null">-- Select unit --</option>
                <option v-for="u in units" :key="u.id" :value="u.id">{{ u.unit }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>Sub Unit</label>
              <select class="form-control" v-model.number="newProduct.subunitId">
                <option :value="null">-- Select sub unit --</option>
                <option v-for="su in filteredSubUnits" :key="su.id" :value="su.id">{{ su.subUnit || su.name || su.unit }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>Category</label>
              <select class="form-control" v-model.number="newProduct.categoryId">
                <option :value="null">-- Select category --</option>
                <option v-for="c in categories" :key="c.id" :value="c.id">{{ c.category }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>Subcategory</label>
              <select class="form-control" v-model.number="newProduct.subcategoryId">
                <option :value="null">-- Select subcategory --</option>
                <option v-for="sc in filteredSubcategories" :key="sc.id" :value="sc.id">{{ getSubcategoryLabel(sc) }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>Purchase Price</label>
              <input type="number" class="form-control" v-model.number="newProduct.pricePurchase" />
            </div>
              <div class="form-group">
                <label>Selling Price</label>
                <input type="number" class="form-control" v-model.number="newProduct.sellingPrice" />
              </div>
              <div class="form-group">
                <label>Brand</label>
                <input class="form-control" v-model="newProduct.brand" />
              </div>
              <div class="form-group">
                <label>Barcode</label>
                <input class="form-control" v-model="newProduct.barcode" />
              </div>
              <div class="form-group">
                <label>Reorder Level</label>
                <input type="number" class="form-control" v-model.number="newProduct.reorderLevel" />
              </div>
              <div class="form-group">
                <label>Tax Rate (%)</label>
                <input type="number" step="0.01" class="form-control" v-model.number="newProduct.taxRate" />
              </div>
            <div class="form-group">
              <label>Description</label>
              <input class="form-control" v-model="newProduct.description" />
            </div>
          </template>
          <template #footer>
            <div style="display:flex; gap:8px; justify-content:flex-end; width:100%">
              <button class="btn btn-secondary" @click="closeNewProductModal" :disabled="creatingProduct">Cancel</button>
              <button class="btn btn-primary" @click="createNewProduct" :disabled="creatingProduct">
                <span v-if="creatingProduct" class="spinner-border spinner-border-sm" role="status" aria-hidden="true" style="margin-right:8px"></span>
                <span v-if="creatingProduct">Creating…</span>
                <span v-else>Create & Add</span>
              </button>
            </div>
          </template>
        </Modal>
        </div>
      </section>
    </div>
  </AppLayout>
</template>
  
  <script>
  
  import { mapGetters, mapActions } from 'vuex'
  import Swal from 'sweetalert2'
  import AppLayout from '../../components/AppLayout.vue';
  import Modal from '../../components/Modal.vue'
  import axios from 'axios'
  import { tenderApi } from '@/api/tender'
  
  export default {
    name: 'AddPurchasePage',
    components: {
      AppLayout,
      Modal,
    },
    data () {
      return {
        token: JSON.parse(localStorage.getItem('access_token')),
        displayItems: "none",
        displayButton: "block",
        supplierId: "",
        tenderId: null,
        paymentId: "",
        discount: 0,
        deliveryDate: '',
        total: 0,
        supplierContact: "",
        productId: "",
        showNewProductModal: false,
        newProduct: {
          name: '',
          code: '',
          unitId: null,
          subunitId: null,
          categoryId: null,
          subcategoryId: null,
          pricePurchase: 0,
          sellingPrice: 0,
          brand: '',
          barcode: '',
          reorderLevel: 0,
          taxRate: 0,
          description: ''
        },
        tenders: [],
        productCode: "",
        productDescription: "",
        productUnit: "",
        productQty: "",
        productRequest: "",
        productPrice: "",
        requisitionNumber: '',
        items: [],
        vat: true,
        purchaseId: null,
        department: null,
        project: '',
        tenderSubmissions: [],
        tenderSubmissionId: null,
        tenderSubmissionDisabled: false,
        creatingPurchase: false,
        creatingProduct: false,
        generatingPurchase: false,
      }
    },
    computed: {
      ... mapGetters(["getPayments", "getSuppliers", "getProducts", "getProductOptions", "getProjects", "getDepartments", "getUnits", "getCategories", "getSubUnits", "getSubCategories"]),
      payments () { return this.getPayments || [] },
      suppliers () { return this.filterPrequalified(this.getSuppliers || []) },
      products () { return this.getProducts || [] },
      units() { return this.getUnits || [] },
      subUnits() { return this.getSubUnits || [] },
      categories() { return this.getCategories || [] },
      subcategories() { return this.getSubCategories || [] },
      // Filter subunits to those that belong to the selected unit in newProduct
      filteredSubUnits() {
        const unitId = this.newProduct && this.newProduct.unitId ? Number(this.newProduct.unitId) : null
        if (!unitId) return this.subUnits || []
        return (this.subUnits || []).filter(su => {
          if (!su) return false
          if (su.unitId && Number(su.unitId) === unitId) return true
          if (su.unit && typeof su.unit === 'object' && su.unit.id && Number(su.unit.id) === unitId) return true
          if (su.unit && (typeof su.unit === 'string' || typeof su.unit === 'number') && String(su.unit) === String(unitId)) return true
          // some API shapes return the parent unit under `subunit`
          if (su.subunit && typeof su.subunit === 'object' && su.subunit.id && Number(su.subunit.id) === unitId) return true
          if (su.subunit && (typeof su.subunit === 'string' || typeof su.subunit === 'number') && String(su.subunit) === String(unitId)) return true
          return false
        })
      },
      // Filter subcategories to those that belong to the selected category in newProduct
      filteredSubcategories() {
        const categoryId = this.newProduct && this.newProduct.categoryId ? Number(this.newProduct.categoryId) : null
        if (!categoryId) return this.subcategories || []
        return (this.subcategories || []).filter(sc => {
          if (!sc) return false
          if (sc.categoryId && Number(sc.categoryId) === categoryId) return true
          if (sc.category && typeof sc.category === 'object' && sc.category.id && Number(sc.category.id) === categoryId) return true
          if (sc.category && (typeof sc.category === 'string' || typeof sc.category === 'number') && String(sc.category) === String(categoryId)) return true
          // some API shapes return the parent category under `subcategory`
          if (sc.subcategory && typeof sc.subcategory === 'object' && sc.subcategory.id && Number(sc.subcategory.id) === categoryId) return true
          if (sc.subcategory && (typeof sc.subcategory === 'string' || typeof sc.subcategory === 'number') && String(sc.subcategory) === String(categoryId)) return true
          return false
        })
      },
      productOptions () { return this.getProductOptions || [] },
      projects() { return this.getProjects || [] },
      departments () { return this.getDepartments || [] },
      productAmount () { 
        const price = Number(this.productPrice) || 0
        const qty = Number(this.productRequest) || 0
        return price * qty
      }
    },
    methods: {
      ...mapActions(["fetchPayments", "fetchSuppliers", "fetchProducts","fetchProjects", "fetchDepartments", "fetchUnits", "fetchCategories", "fetchSubUnits", "fetchSubCategories"]),
      getSubcategoryLabel(sc) {
        if (!sc) return '';
        if (typeof sc === 'string') return sc;
        if (sc.category && typeof sc.category === 'string') return sc.category;
        if (sc.name && typeof sc.name === 'string') return sc.name;
        if (sc.subcategory && sc.subcategory.category) return sc.subcategory.category;
        // Fallback to any nested category string
        if (sc.category && typeof sc.category === 'object' && sc.category.category) return sc.category.category;
        return '';
      },
      onTenderChange() {
        // ensure items and tender-related state are cleared when user selects the None option
        if (!this.tenderId) {
          this.supplierId = ''
          this.supplierContact = ''
          this.tenderSubmissions = []
          this.tenderSubmissionId = null
          this.tenderSubmissionDisabled = false
          this.items = []
        }
      },
      async fetchTenders() {
          try {
            const res = await fetch((process.env.VUE_APP_URL) + '/tender?status=PUBLISHED', {
              headers: { 'Accept': 'application/json', 'Authorization': this.token ? `Bearer ${this.token}` : '' }
            })
            if (!res.ok) return this.tenders = []
            const data = await res.json()
            this.tenders = data.data || []
            // Filter tenders to only those that have at least one AWARDED submission
            try {
              const subsRes = await tenderApi.getAllSubmissions({ status: 'AWARDED', limit: 1000 })
              const subsPayload = subsRes && subsRes.data ? subsRes.data : subsRes
              const awardedSubs = Array.isArray(subsPayload) ? subsPayload : (Array.isArray(subsPayload.data) ? subsPayload.data : [])
              const awardedTenderIds = new Set(awardedSubs.map(s => s.tenderId || (s.tender && s.tender.id)).filter(Boolean))
              this.tenders = (this.tenders || []).filter(t => awardedTenderIds.has(t.id))
            } catch (err) {
              console.error('Error fetching awarded submissions for tender filter', err)
            }
          } catch (err) {
            console.error('Error fetching tenders', err)
            this.tenders = []
          }
        },

          async fetchAwardedSubmissions(tenderId) {
            if (!tenderId) {
              this.tenderSubmissions = []
              return
            }
            try {
              const res = await tenderApi.getTenderSubmissions(tenderId, { status: 'AWARDED' })
              const payload = res && res.data ? res.data : res
              if (Array.isArray(payload)) this.tenderSubmissions = payload
              else if (Array.isArray(payload.data)) this.tenderSubmissions = payload.data
              else this.tenderSubmissions = []
              // auto-select and disable when exactly one awarded submission exists
              if (this.tenderSubmissions.length === 1) {
                this.tenderSubmissionId = this.tenderSubmissions[0].id
                this.tenderSubmissionDisabled = true
              } else {
                this.tenderSubmissionDisabled = false
              }
            } catch (err) {
              console.error('Error fetching awarded submissions', err)
              this.tenderSubmissions = []
              this.tenderSubmissionDisabled = false
            }
          },

        async fetchTenderDetails(id) {
          if (!id) return
          try {
            const res = await fetch((process.env.VUE_APP_URL) + `/tender/${id}`, {
              headers: { 'Accept': 'application/json', 'Authorization': this.token ? `Bearer ${this.token}` : '' }
            })
            if (!res.ok) return
            const data = await res.json()
            const tender = data.data || data.tender || data
            // find awarded submission
            const awarded = (tender.submissions || []).find(s => s.status === 'AWARDED')
            if (awarded) {
              // prefer explicit supplier id from submission
              const supplierIdFromSubmission = awarded.supplierId || (awarded.Supplier && awarded.Supplier.id) || awarded.supplier || null
              if (supplierIdFromSubmission) {
                this.supplierId = supplierIdFromSubmission
                // try to find supplier object for contact info
                const matchedById = (this.suppliers || []).find(s => s.id === supplierIdFromSubmission) || (this.getSuppliers || []).find(s => s.id === supplierIdFromSubmission)
                if (matchedById) this.supplierContact = matchedById.address || matchedById.contact || matchedById.phone || matchedById.email || ''
              } else if (awarded.companyEmail) {
                // try to find supplier by email
                const matched = (this.suppliers || []).find(s => s.email && s.email.toLowerCase() === awarded.companyEmail.toLowerCase()) || (this.getSuppliers || []).find(s => s.email && s.email.toLowerCase() === awarded.companyEmail.toLowerCase())
                if (matched) {
                  this.supplierId = matched.id
                  this.supplierContact = matched.address || matched.contact || matched.phone || matched.email || ''
                } else {
                  // no matching supplier record; prefill contact email field
                  this.supplierContact = awarded.companyEmail || awarded.companyName || ''
                }
              } else if (awarded.companyName) {
                // try to match by company name (case-insensitive substring)
                const matched = (this.suppliers || []).find(s => s.name && s.name.toLowerCase().includes(awarded.companyName.toLowerCase())) || (this.getSuppliers || []).find(s => s.name && s.name.toLowerCase().includes(awarded.companyName.toLowerCase()))
                if (matched) {
                  this.supplierId = matched.id
                  this.supplierContact = matched.address || matched.contact || matched.phone || matched.email || ''
                } else {
                  this.supplierContact = awarded.companyName || ''
                }
              }
            }
            // Prefill requisition number from linked purchase request if available
            try {
              if (tender.purchaseRequestId) {
                const prRes = await fetch((process.env.VUE_APP_URL || process.env.VUE_APP_URL) + `/purchase-requests/${tender.purchaseRequestId}`, {
                  headers: { 'Accept': 'application/json', 'Authorization': this.token ? `Bearer ${this.token}` : '' }
                })
                if (prRes && prRes.ok) {
                  const prData = await prRes.json()
                  const pr = prData.data || prData || {}
                  this.requisitionNumber = pr.purchaseRequestNo || pr.requestNumber || (pr.id ? `PR${String(pr.id).padStart(6, '0')}` : '')
                  // Prefill project from purchase request. Accept several shapes: string, nested Project, or projectId.
                  try {
                    let prProjectName = null
                    if (pr.project && typeof pr.project === 'string') prProjectName = pr.project
                    else if (pr.projectName) prProjectName = pr.projectName
                    else if (pr.Project && (pr.Project.name || pr.Project.title)) prProjectName = pr.Project.name || pr.Project.title
                    else if (pr.projectId) {
                      const proj = (this.getProjects || []).find(p => p.id === pr.projectId) || (this.projects || []).find(p => p.id === pr.projectId)
                      if (proj) prProjectName = proj.name
                    }
                    if (prProjectName) this.project = prProjectName
                  } catch (e) {
                    // ignore mapping errors
                  }

                  // Prefill department from purchase request. Accept string, nested Department, or departmentId.
                          // Prefill department: map various shapes to department id
                          let prDeptId = null
                          if (pr.departmentId) {
                            prDeptId = pr.departmentId
                          } else if (pr.Department && pr.Department.id) {
                            prDeptId = pr.Department.id
                          } else if (pr.department && typeof pr.department === 'string') {
                            // try to find a department by name
                            const dept = (this.getDepartments || []).find(d => d.name && d.name.toLowerCase() === pr.department.toLowerCase()) || (this.departments || []).find(d => d.name && d.name.toLowerCase() === pr.department.toLowerCase())
                            if (dept) prDeptId = dept.id
                          } else if (pr.departmentName) {
                            const dept = (this.getDepartments || []).find(d => d.name && d.name.toLowerCase() === pr.departmentName.toLowerCase()) || (this.departments || []).find(d => d.name && d.name.toLowerCase() === pr.departmentName.toLowerCase())
                            if (dept) prDeptId = dept.id
                          }
                          if (prDeptId) this.department = prDeptId
                } else {
                  this.requisitionNumber = ''
                }
              } else {
                this.requisitionNumber = ''
              }
            } catch (e) {
              console.error('Failed to prefill requisition number from purchase request', e)
              this.requisitionNumber = ''
            }
          } catch (err) {
            console.error('Error fetching tender details', err)
          }
        },

        async loadTenderItemsForPreview(tenderId) {
          try {
            let res
            try {
              res = await tenderApi.getTenderItemsWithAvailability(tenderId)
            } catch (e) {
              // fallback if availability endpoint is not present yet (server not restarted)
              console.warn('Availability endpoint failed, falling back to basic items endpoint', e)
              res = await tenderApi.getTenderItems(tenderId)
            }

            const payload = res && res.data ? res.data : res
            const items = payload.items || payload || []
            console.log('Tender items for preview:', items)
            // Filter out items that have negative available quantity, then map into the
            // same shape the purchase items table expects. Keep items where
            // `availableQuantity` is null/undefined (unknown) or >= 0. Log intermediate
            // values to help diagnose why rows aren't rendering.
            const filtered = (items || []).filter(it => {
              const aq = it.availableQuantity
              // remove items with zero available quantity; keep unknown (null/undefined) or positive availability
              return aq === null || aq === undefined || Number(aq) > 0
            })

            console.log('Filtered tender items for preview:', filtered)

            const mapped = filtered.map((it, idx) => {
              const prod = it.product || {}
              const tenderedQty = it.quantity || it.quantityProcessed || it.processedQuantity || 0
              // default requested quantity to availableQuantity when present,
              // otherwise fall back to any explicit requested quantity or the tendered quantity
              const requestedQty = (it.availableQuantity !== undefined && it.availableQuantity !== null)
                ? it.availableQuantity
                : (it.requestedQuantity || it.requestQuantity || it.quantityRequested || tenderedQty)
              return {
                id: `t-${tenderId}-${idx}`,
                Product: {
                  id: prod.id || it.productId || null,
                  name: prod.name || it.description || '',
                  code: prod.code || prod.productCode || '',
                  unit: { unit: prod.unit || (prod.unit && prod.unit.unit) || '' },
                },
                description: it.description || prod.name || '',
                tenderedQuantity: tenderedQty,
                availableQuantity: (it.availableQuantity !== undefined ? it.availableQuantity : null),
                quantity: requestedQty,
                price: it.unitPrice || it.estimatedUnitPrice || it.price || 0,
              }
            })

            console.log('Mapped tender items for preview:', mapped)
            this.items = mapped
          } catch (err) {
            console.error('Failed to load tender items for preview', err)
            this.items = []
          }
        },
        
        async generatePurchase () {
          this.generatingPurchase = true
          if (this.tenderId) {
            await this.postPurchase()
          }
          if (!this.purchaseId) return Swal.fire({ icon: 'error', title: 'No purchase', text: 'Please create a purchase first' })
          // validate item quantities against availableQuantity before generating
          const invalid = (this.items || []).filter(i => (i.availableQuantity !== null && i.availableQuantity !== undefined) && Number(i.quantity) > Number(i.availableQuantity))
          if (invalid.length > 0) {
            const names = invalid.map(i => (i.Product && (i.Product.code || i.Product.name)) || i.description).join(', ')
            return Swal.fire({ icon: 'error', title: 'Invalid quantities', text: `Requested quantity exceeds available for: ${names}` })
          }
          
          try {
            const requestOptions = {
              method: "POST",
              headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
              body: JSON.stringify({ products: this.items })
            };
            const res = await fetch((process.env.VUE_APP_URL || process.env.VUE_APP_URL) + '/purchases/generate/' + this.purchaseId, requestOptions)
            // parse safely
            let data = null
            const ct = res.headers.get('content-type') || ''
            if (ct.includes('application/json')) {
              try { data = await res.json() } catch (e) { data = null }
            }
            if (res.ok && data && data.status == true) {
              Swal.fire({
                position: 'top-center',
                icon: 'success',
                title: 'Purchase Generated',
                showConfirmButton: false,
                timer: 1500
              })
              this.$router.push('/purchases')
            } else {
              const msg = (data && data.message) || 'Purchase not generated'
              Swal.fire({ icon: 'error', title: 'Purchase not generated', text: msg })
            }
          } catch (err) {
            console.error('Error generating purchase', err)
            Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to generate purchase' })
          } finally {
            this.generatingPurchase = false
          }
        },

        filterPrequalified(arr) {
          return arr.filter(item => {
            const v = item?.prequalified
            return v === true || v === 'true' || v === 1 || v === '1' || String(v).toLowerCase() === 'yes'
          });
        },

        async postPurchase () {
            if(this.tenderId) 
              Swal.fire({
                  icon: 'error',
                  title: 'Purchase creation not allowed',
                  text: 'Purchase must be attached to a tender with an awarded submission.'
              })

            this.creatingPurchase = true
            //this.generatingPurchase = true
            try {
              const body = {
                departmentId: this.department ? Number(this.department) : undefined,
                project: this.project,
                supplierId: this.supplierId,
                tenderId: this.tenderId,
                discount: this.discount,
                vat: this.vat
              }
              if (this.deliveryDate) {
                try {
                  body.deliveryDate = new Date(this.deliveryDate).toISOString();
                } catch (e) {
                  body.deliveryDate = this.deliveryDate;
                }
              }
              // include paymentId only when set to a valid value
              if (this.paymentId !== undefined && this.paymentId !== null && this.paymentId !== '') {
                body.paymentId = Number(this.paymentId)
              }
              const requestOptions = {
                  method: "POST",
                  headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
                  body: JSON.stringify(body)
              };
              const res = await fetch(process.env.VUE_APP_URL+'/purchases', requestOptions)
              const data = await res.json()
              if(data.status == true){
                  this.purchaseId = data.purchase.id
                  this.displayButton = "none"
                  this.displayItems = "block"
                  // If a tender was selected, copy tender items into the created purchase
                 /* if (this.tenderId) {
                    try {
                      await this.addTenderItemsToPurchase(this.tenderId, this.purchaseId)
                    } catch (err) {
                      console.error('Failed to add tender items to purchase', err)
                    }
                  }*/
                  // fetch processed items for this purchase
              }else{
                  Swal.fire({
                      icon: 'error',
                      title: 'Product not created',
                      text: data.message
                  })
              }
            } catch (err) {
              console.error('Error creating purchase', err)
              Swal.fire({ icon: 'error', title: 'Failed', text: 'Failed to create purchase' })
            } finally {
              this.creatingPurchase = false
            }
        },

        async addTenderItemsToPurchase(tenderId, purchaseId) {
          if (!tenderId || !purchaseId) return
          try {
            const res = await tenderApi.getTenderItems(tenderId)
            const payload = res && res.data ? res.data : res
            const items = payload.items || payload || []
            console.log('Fetched tender items payload:', payload)
            console.log('Fetched tender items:', items)
            for (const it of items) {
              const prod = it.product || {}
              const body = {
                description: it.description || prod.name || '',
                quantity: it.quantityProcessed || it.quantity || it.processedQuantity || 0,
                price: it.unitPrice || it.estimatedUnitPrice || it.price || 0,
                purchaseId: purchaseId,
                productId: prod.id || it.productId || undefined,
              }
              try {
                const requestOptions = {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.token },
                  body: JSON.stringify(body),
                }
                await fetch((process.env.VUE_APP_URL || process.env.VUE_APP_URL) + '/purchases/products', requestOptions)
              } catch (e) {
                console.error('Failed to add purchase product', e)
              }
            }
          } catch (err) {
            console.error('Error fetching tender items', err)
          }
        },

        async fetchPurchaseItems() {
          if (!this.purchaseId) return
          try {
            const res = await fetch(process.env.VUE_APP_URL + '/purchases/' + this.purchaseId, {
              headers: { 'Accept': 'application/json', 'Authorization': 'Bearer ' + this.token }
            })
            const data = await res.json()
            // assume API returns purchase with items
            this.items = data.purchase?.items || data.items || []
          } catch (err) {
            console.error('Error fetching purchase items', err)
          }
        },

        async postProduct() {
          const requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
                body: JSON.stringify({ 
                  description: this.productDescription,
                  quantity: this.productRequest,
                  price: this.productPrice,
                  purchaseId: this.purchaseId,
                  productId: this.productId,
                })
            };
            const res = await fetch(process.env.VUE_APP_URL+'/purchases/products', requestOptions)
            const data = await res.json()
            if(data.status == true){
              this.productRequest = ""
              this.productDescription = ""
              this.productPrice = ""
              this.items = data.products
            }else{
                Swal.fire({
                    icon: 'error',
                    title: 'Product not added',
                    text: data.message
                })
            }
        },
        async deleteProduct(id) {
          // If the item id is not a numeric DB id (e.g., preview id like 't-<tid>-<idx>')
          // or there is no saved purchase yet, remove locally without calling API.
          const isNumericId = String(id).match(/^\d+$/)
          if (!isNumericId || !this.purchaseId) {
            this.items = (this.items || []).filter(i => i.id !== id)
            return
          }

          const requestOptions = {
            method: "DELETE",
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token }
          };
          const res = await fetch(process.env.VUE_APP_URL+'/purchases/products/'+id+'/'+this.purchaseId, requestOptions)
          const data = await res.json()
          if(data.status == true){
            this.items = data.products
          }else{
            Swal.fire({
              icon: 'error',
              title: 'Purchase Order Product not deleted',
              text: data.message
            })
          }
        },

        openNewProductModal() {
          this.newProduct = {
            name: '',
            code: '',
            unitId: null,
            subunitId: null,
            categoryId: null,
            subcategoryId: null,
            pricePurchase: 0,
            sellingPrice: 0,
            brand: '',
            barcode: '',
            reorderLevel: 0,
            taxRate: 0,
            description: ''
          }
          this.showNewProductModal = true
        },
        closeNewProductModal() {
          this.showNewProductModal = false
        },
        async createNewProduct() {
          if (!this.newProduct.name) return Swal.fire({ icon: 'error', title: 'Name required', text: 'Please enter a product name' })
          this.creatingProduct = true
          try {
            const form = new FormData()
            form.append('name', this.newProduct.name)
            if (this.newProduct.code) form.append('code', this.newProduct.code)
            if (this.newProduct.unitId) form.append('unitId', String(this.newProduct.unitId))
            if (this.newProduct.subunitId) form.append('subunitId', String(this.newProduct.subunitId))
            if (this.newProduct.categoryId) form.append('categoryId', String(this.newProduct.categoryId))
            if (this.newProduct.subcategoryId) form.append('subcategoryId', String(this.newProduct.subcategoryId))
            if (this.newProduct.pricePurchase !== undefined) form.append('pricePurchase', String(this.newProduct.pricePurchase))
            if (this.newProduct.sellingPrice !== undefined) form.append('sellingPrice', String(this.newProduct.sellingPrice))
            if (this.newProduct.brand) form.append('brand', this.newProduct.brand)
            if (this.newProduct.barcode) form.append('barcode', this.newProduct.barcode)
            if (this.newProduct.reorderLevel !== undefined) form.append('reorderLevel', String(this.newProduct.reorderLevel))
            if (this.newProduct.taxRate !== undefined) form.append('taxRate', String(this.newProduct.taxRate))
            if (this.newProduct.description) form.append('description', this.newProduct.description)

            const res = await axios.post(process.env.VUE_APP_URL + '/products', form, {
              headers: { 'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + this.token }
            })

            const data = res && res.data ? res.data : res
            if (data && (data.status === true || data.id || data.product)) {
              const created = data.product || data.data || data
              await this.fetchProducts()
              this.productId = created.id || created.productId || created.id
              this.closeNewProductModal()

              if (this.purchaseId) {
                this.productDescription = this.newProduct.description || ''
                this.productRequest = 1
                this.productPrice = this.newProduct.pricePurchase || 0
                await this.postProduct()
              } else {
                const unit = (created.unit && created.unit.unit) ? created.unit : { unit: created.unit || '' }
                const item = {
                  id: `local-${Date.now()}`,
                  Product: { id: created.id, name: created.name, code: created.code, unit },
                  description: this.newProduct.description || created.name || '',
                  tenderedQuantity: 0,
                  availableQuantity: null,
                  quantity: 1,
                  price: this.newProduct.pricePurchase || 0
                }
                this.items.push(item)
              }
              // success — no modal shown as requested
            } else {
              const msg = (data && data.message) || 'Failed to create product'
              Swal.fire({ icon: 'error', title: 'Error', text: msg })
            }
          } catch (err) {
            console.error('Failed to create product', err)
            Swal.fire({ icon: 'error', title: 'Error', text: err.response?.data?.message || 'Failed to create product' })
          } finally {
            this.creatingProduct = false
          }
        }
        
    },
    
    mounted(){
      this.fetchPayments()
      this.fetchSuppliers()
      this.fetchProducts()
      this.fetchProjects()
      this.fetchDepartments()
      this.fetchUnits()
      this.fetchCategories()
      this.fetchSubUnits()
      this.fetchSubCategories()
      this.fetchTenders()
      // if we already have a purchaseId (editing), load its items
      if (this.purchaseId) this.fetchPurchaseItems()
      // Preselect tender/submission/supplier when provided via query params
      try {
        const q = this.$route && this.$route.query ? this.$route.query : null
        if (q && q.tenderId) {
          this.tenderId = Number(q.tenderId) || q.tenderId
          // fetch tender details and awarded submissions then set submission/supplier
          this.fetchTenderDetails(this.tenderId)
          this.fetchAwardedSubmissions(this.tenderId).then(() => {
            if (q.tenderSubmissionId) this.tenderSubmissionId = Number(q.tenderSubmissionId) || q.tenderSubmissionId
            if (q.supplierId) this.supplierId = Number(q.supplierId) || q.supplierId
          }).catch(() => {
            if (q.tenderSubmissionId) this.tenderSubmissionId = Number(q.tenderSubmissionId) || q.tenderSubmissionId
            if (q.supplierId) this.supplierId = Number(q.supplierId) || q.supplierId
          })
        }
      } catch (e) {
        // ignore query mapping errors
      }
    },
    watch: {
      tenderId(val){
        if (val) {
          this.fetchTenderDetails(val)
          this.fetchAwardedSubmissions(val)
          // load tender products for preview when creating a new purchase
          if (!this.purchaseId) {
            this.loadTenderItemsForPreview(val)
          }
        }
        else {
          // clear supplier selection if tender cleared
          this.supplierId = ''
          this.supplierContact = ''
          this.tenderSubmissions = []
          this.tenderSubmissionId = null
          this.tenderSubmissionDisabled = false
          // clear any loaded tender items when user selects "None"
          this.items = []
        }
      },
      async tenderSubmissionId(val){
        if (!val) return
        const submission = (this.tenderSubmissions || []).find(s => s.id === val)
        if (!submission) return
        // prefer explicit supplier id from submission
        const supplierIdFromSubmission = submission.supplierId || (submission.Supplier && submission.Supplier.id) || submission.supplier || null
        if (supplierIdFromSubmission) {
          this.supplierId = supplierIdFromSubmission
          const matchedById = (this.suppliers || []).find(s => s.id === supplierIdFromSubmission) || (this.getSuppliers || []).find(s => s.id === supplierIdFromSubmission)
          if (matchedById) this.supplierContact = matchedById.address || matchedById.contact || matchedById.phone || matchedById.email || ''
        } else if (submission.companyEmail) {
          const matched = (this.suppliers || []).find(s => s.email && s.email.toLowerCase() === submission.companyEmail.toLowerCase()) || (this.getSuppliers || []).find(s => s.email && s.email.toLowerCase() === submission.companyEmail.toLowerCase())
          if (matched) {
            this.supplierId = matched.id
            this.supplierContact = matched.address || matched.contact || matched.phone || matched.email || ''
          } else {
            this.supplierContact = submission.companyEmail || submission.companyName || ''
          }
        }
        // Prefill product prices from the selected submission's quotation (if available)
        try {
          const token = this.token
          const res = await fetch((process.env.VUE_APP_URL || '') + `/tender/submission/${val}`, {
            headers: { 'Accept': 'application/json', 'Authorization': token ? `Bearer ${token}` : '' }
          })
          if (res && res.ok) {
            const data = await res.json()
            const payload = data.data || data
            const qRaw = payload && (payload.quotation || payload.Quotation)
            let q = null
            if (qRaw) {
              try { q = typeof qRaw === 'string' ? JSON.parse(qRaw) : qRaw } catch (e) { q = qRaw }
            }
            if (q && Array.isArray(q.items) && (this.items || []).length > 0) {
              // map by product id, code, or name
              const priceMap = {}
              q.items.forEach(it => {
                const keyId = it.id ? String(it.id) : null
                const name = it.name || it.description || ''
                const code = it.code || ''
                const unitPrice = Number(it.unitPrice != null ? it.unitPrice : (it.price != null ? it.price : it.total || 0)) || 0
                if (keyId) priceMap[`id:${keyId}`] = unitPrice
                if (code) priceMap[`code:${String(code).toLowerCase()}`] = unitPrice
                if (name) priceMap[`name:${String(name).toLowerCase()}`] = unitPrice
              })
              // Apply prices to this.items by matching product id, code, or name
              this.items = (this.items || []).map(it => {
                try {
                  const prodId = it.Product && it.Product.id ? String(it.Product.id) : null
                  const code = (it.Product && (it.Product.code || it.Product.productCode)) || it.code || ''
                  const name = it.description || (it.Product && (it.Product.name || it.Product.description)) || ''
                  let matchedPrice = null
                  if (prodId && priceMap[`id:${prodId}`] != null) matchedPrice = priceMap[`id:${prodId}`]
                  else if (code && priceMap[`code:${String(code).toLowerCase()}`] != null) matchedPrice = priceMap[`code:${String(code).toLowerCase()}`]
                  else if (name && priceMap[`name:${String(name).toLowerCase()}`] != null) matchedPrice = priceMap[`name:${String(name).toLowerCase()}`]
                  if (matchedPrice != null) {
                    return { ...it, price: matchedPrice }
                  }
                } catch (e) {
                  // ignore mapping errors per item
                }
                return it
              })
            }
          }
        } catch (e) {
          console.warn('Failed to prefill prices from submission quotation', e)
        }
      },
      supplierId(newValue){
        const supplierObj = this.suppliers.find(i => i.id === newValue) || {}
        this.supplierContact = supplierObj.address || supplierObj.contact || supplierObj.phone || supplierObj.email || ''
      },
      productId(newValue){
        const item = this.products.find(i => i.id === newValue) || {}
        this.productCode = item.code || ''
        this.productUnit = (item.unit && item.unit.unit) || ''
      },
      'newProduct.unitId'() {
        // if selected subunit no longer matches the chosen unit, clear it
        const cur = this.newProduct && this.newProduct.subunitId
        if (!cur) return
        const match = (this.filteredSubUnits || []).find(su => Number(su.id) === Number(cur))
        if (!match) this.newProduct.subunitId = null
      },
      'newProduct.categoryId'() {
        // if selected subcategory no longer matches the chosen category, clear it
        const cur = this.newProduct && this.newProduct.subcategoryId
        if (!cur) return
        const match = (this.filteredSubcategories || []).find(sc => Number(sc.id) === Number(cur))
        if (!match) this.newProduct.subcategoryId = null
      },
      items: {
        handler(newValue){
          var sum = 0;
          (newValue || []).forEach(e => {
            const price = Number(e.price) || 0
            const qty = Number(e.quantity) || 0
            sum += price * qty
          });
          this.total = sum
        },
        deep: true
      }
    }
  }
  </script>


<style lang="scss">
$text-color: #000000;
input[readonly]{
  background-color: #cfcece !important;
}

select {
  /* inline SVG */
  background: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20256%20448%22%20enable-background%3D%22new%200%200%20256%20448%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E.arrow%7Bfill%3A%23424242%3B%7D%3C%2Fstyle%3E%3Cpath%20class%3D%22arrow%22%20d%3D%22M255.9%20168c0-4.2-1.6-7.9-4.8-11.2-3.2-3.2-6.9-4.8-11.2-4.8H16c-4.2%200-7.9%201.6-11.2%204.8S0%20163.8%200%20168c0%204.4%201.6%208.2%204.8%2011.4l112%20112c3.1%203.1%206.8%204.6%2011.2%204.6%204.4%200%208.2-1.5%2011.4-4.6l112-112c3-3.2%204.5-7%204.5-11.4z%22%2F%3E%3C%2Fsvg%3E%0A"), #fff;
  background-position: right 10px center;
  background-repeat: no-repeat;
  background-size: auto 50%;
  border-radius: 3px;
  height: 45px;
  border: 1px solid #b4c7e7 !important;
  padding: 5px 30px 5px 10px;
  // disable default appearance
  outline: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  &::-ms-expand { display: none };
  &.full{
    width: 100%;
  }
  &:focus, &:hover{
    background: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20256%20448%22%20enable-background%3D%22new%200%200%20256%20448%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E.arrow%7Bfill%3A%23424242%3B%7D%3C%2Fstyle%3E%3Cpath%20class%3D%22arrow%22%20d%3D%22M255.9%20168c0-4.2-1.6-7.9-4.8-11.2-3.2-3.2-6.9-4.8-11.2-4.8H16c-4.2%200-7.9%201.6-11.2%204.8S0%20163.8%200%20168c0%204.4%201.6%208.2%204.8%2011.4l112%20112c3.1%203.1%206.8%204.6%2011.2%204.6%204.4%200%208.2-1.5%2011.4-4.6l112-112c3-3.2%204.5-7%204.5-11.4z%22%2F%3E%3C%2Fsvg%3E%0A"), #fff;
    border: 1px solid $text-color;
    background-position: right 10px center;
    background-repeat: no-repeat;
    background-size: auto 50%;
  }
}


$primary: #d2d2d2;
$green: #000000;
$white: #ffffff;
  .check-button{
        display: flex;
        align-items: center;
        gap: 10px;
      }
      .form-group{
        .components-button {
          display: flex;
          align-items: center;
          justify-content: left;
          span.switcher {
            position: relative;
            width: 156px;
            height: 56px;
            border-radius: 10px;
            input {
              appearance: none;
              position: relative;
              width: 130px;
              height: 40px;
              border-radius: 3px;
              border-color: #d2d2d2 !important;
              background: $primary;
              outline: none;
              font-family: 'Oswald', sans-serif;
              &:before, &:after {
                z-index: 2;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                color: $white;
              }
              &:before {
                content: 'Yes';
                left: 14px;
                font-weight: 600;
                font-size: 14px;
                line-height: 33px;
                color: #FFFFFF;
              }
              &:after {
                content: 'No';
                right: 14px;
                font-weight: 600;
                font-size: 17px;
                line-height: 33px;
                color: #FFFFFF;
              }
            }
            label {
              z-index: 1;
              position: absolute;
              width: 55px;
              height: 32px;
              margin: 0;
              top: 4px;
              left: 71px !important;
              border-radius: 3px;
            }
            &.switcher-1, &.switcher-2 {
              input {
                transition: .25s -.1s;
                &:checked {
                  background: $primary;
                  &:before {
                    color: $white;
                    transition: color .5s .2s;
                  }
                  &:after {
                    color: #ffffff;
                    transition: color .5s;
                  }
                  & + label {
                    left: 4px !important;
                    background: $green;
                    transition: left .5s, right .4s .2s;
                    height: 30px !important;
                  }
                }
                &:not(:checked) {
                  background: $primary;
                  transition: background .5s -.1s;
                  &:before {
                    color: #ffffff;
                    transition: color .5s;
                  }
                  &:after {
                    color: $white;
                    transition: color .5s .2s;
                  }
                  & + label {
                    left: 100px;
                    right: 10px;
                    background: $green;
                    transition: left .4s .2s, right .5s, background .35s -.1s;
                    height: 30px !important;
                  }
                }
              }
            }
          }
        }
      }


        </style>